<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- privateNumberId -->
            <div class="md:tw-w-1/4 xl:tw-w-1/4">
              <private-number-select-search
                *ngIf="!formPageConfig.isEditMode"
                type="descendantPrivateNumbers"
                [control]="form?.get('privateNumberId')"
                [label]="fields + 'privateNumberNumber'"
                [value]="model.privateNumberId"
                (itemChange)="model.privateNumberId = $event.id"
              >
              </private-number-select-search>
              <form-field
                *ngIf="formPageConfig.isEditMode"
                [value]="formPageConfig.editData.privateNumberNumber"
                [control]="form?.get('privateNumberId')"
                [label]="fields + 'privateNumberNumber'"
              >
              </form-field>
            </div>

            <!-- dailySendLimit -->
            <div class="md:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('dailySendLimit')"
                [label]="fields + 'dailySendLimit'"
                [(value)]="model.dailySendLimit"
              >
              </form-field>
            </div>

            <!-- monthlySendLimit -->
            <div class="md:tw-w-1/4">
              <form-field
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('monthlySendLimit')"
                [label]="fields + 'monthlySendLimit'"
                [(value)]="model.monthlySendLimit"
              >
              </form-field>
            </div>
          </div>

          <div class="row">
            <!-- organizationIds -->
            <organization-selection-list
              type="descendantAndItselfList"
              searchLabel="messages.searchInOrganizations"
              [values]="model.organizationIds"
              (values)="model.organizationIds = $event"
            >
            </organization-selection-list>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
